import React from "react";
import Image from "next/image";

function Community() {
  return (
    <div className="flex flex-col items-center">
      <div className="flex -space-x-[20px] lg:-space-x-[25px]">
        <div className="w-[80px] h-[80px] lg:w-[100px] lg:h-[100px] rounded-full overflow-hidden relative z-30">
          <Image src="/assets/pet-tag/user/user-1.png" alt="User 1" fill />
        </div>

        <div className="w-[80px] h-[80px] lg:w-[100px] lg:h-[100px] rounded-full overflow-hidden relative z-20">
          <Image src="/assets/pet-tag/user/user-2.png" alt="User 2" fill />
        </div>

        <div className="w-[80px] h-[80px] lg:w-[100px] lg:h-[100px] rounded-full overflow-hidden relative z-10">
          <Image src="/assets/pet-tag/user/user-3.png" alt="User 3" fill />
        </div>

        <div className="w-[80px] h-[80px] lg:w-[100px] lg:h-[100px] rounded-full overflow-hidden relative">
          <Image src="/assets/pet-tag/user/user-4.png" alt="User " fill />
        </div>
      </div>

      <p className="text-white text-xl lining-nums font-bold capitalize tracking-[0.48px] leading-[20px] mt-3 lg:leading-[24px]  lg:mt-4 lg:text-2xl">
        12,000+ users community
      </p>
    </div>
  );
}

export default Community;
